import React from "react";
import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import About from "../components/site/About";
import ComingSoon from "../components/site/ComingSoon";
import BooksPreview from "../components/site/BooksPreview";
import Newsletter from "../components/site/Newsletter";
import Suggestions from "../components/site/Suggestions";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";
import useReveal from "../hooks/useReveal";
import FeaturedPlanner from "../components/site/FeaturedPlanner";
import NewArrivals from "../components/site/NewArrivals";

export default function Landing() {
    useReveal();
    return (
        <main
            className="min-h-screen bg-cream-50 text-ink-900 font-sans"
            data-testid="landing-page"
        >
            <Navbar />
            <Hero />
            <FeaturedPlanner />
            <NewArrivals />
            <About />
            <ComingSoon />
            <BooksPreview />
            <Newsletter />
            <Suggestions />
            <Contact />
            <Footer />
        </main>
    );
}
